import TabletBannerImage from "../../../atoms/images/TabletBannerImage";

const TabletBanner = () => {
  return (
    <div className="logo-background w-full">
      <TabletBannerImage />
    </div>
  );
};

export default TabletBanner;
